const BASE = import.meta.env.VITE_API_URL || "";

export async function refreshAccessToken(): Promise<string | null> {
  const res = await fetch(`${BASE}/api/auth/refresh`, {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) return null;
  const data = await res.json();
  if (data.token) {
    localStorage.setItem("token", data.token);
    return data.token;
  }
  return null;
}
